"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimatorSchema = exports.messageSchema = exports.ChatSchema = void 0;
const PlayerDTO_1 = require("./PlayerDTO");
const zod_1 = require("zod");
const AnimatorSchema = zod_1.z.object({
    animatorName: zod_1.z.string(),
    isCoanimator: zod_1.z.boolean(),
});
exports.AnimatorSchema = AnimatorSchema;
const personSchema = zod_1.z.union([PlayerDTO_1.PlayerDTOSchema, AnimatorSchema]);
const messageSchema = zod_1.z.object({
    person: personSchema,
    content: zod_1.z.string(),
    date: zod_1.z.date(),
});
exports.messageSchema = messageSchema;
const ChatSchema = zod_1.z.array(messageSchema);
exports.ChatSchema = ChatSchema;
